import React, { useState } from "react";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";

const CommonButton = ({ name, handleOnClick }) => {
  const [isActive, setIsActive] = useState(false);

  const handleClick = (event) => {
    if (handleOnClick) {
      handleOnClick(event); // Pass the event object to the handler
    } else {
      console.warn("Warning: handleOnClick is not provided for CommonButton.");
      setIsActive(true);
      setTimeout(() => {
        setIsActive(false);
      }, 3000);
    }
  };

  return (
    <>
      {isActive && (
        <Stack
          sx={{ width: "30%" }}
          spacing={10}
          style={{
            position: "fixed",
            top: 5,
            zIndex: 1200,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Alert severity="error" onClose={() => setIsActive(false)}>
            Warning: handleOnClick is missing!
          </Alert>
        </Stack>
      )}

      <Button
        onClick={handleClick}
        sx={{
          backgroundColor: "#33499F",
          color: "white",
          boxShadow: "4px 2px 4px rgb(110, 142, 237)",
          marginTop: "10px",
          marginBottom: "10px",
          fontSize: "14px",
          minWidth: "100px",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#33499F",
          },
          display: "flex",
        }}
        variant="contained"
      >
        {name}
      </Button>
    </>
  );
};

export default CommonButton;
